import { MinfinMainSection } from './MinfinMainSection';

export default MinfinMainSection;
